import { FontConfig } from "../types"

export const BODY_5XL_CONFIG: FontConfig = {
  title: "BODY/5xl",
  mobile: {
    family: { value: "DM Sans", tw: "font-sans" },
    weight: { value: "Medium", tw: "font-medium" },
    size: { px: 26, tw: "text-[26px]" },
    lineHeight: { px: 36, tw: "leading-[36px]" },
  },
  tablet: {
    family: { value: "DM Sans", tw: "font-sans" },
    weight: { value: "Medium", tw: "font-medium" },
    size: { px: 32, tw: "text-[32px]" },
    lineHeight: { px: 46, tw: "leading-[46px]" },
  },
  desktop: {
    family: { value: "DM Sans", tw: "font-sans" },
    weight: { value: "Medium", tw: "font-medium" },
    size: { px: 40, tw: "text-[40px]" },
    lineHeight: { px: 57, tw: "leading-[57px]" },
  },
}
